<template>
  <div class="app-container">
    <el-row :gutter="10" class="mb8">
<!--      <el-col :span="1.5">
        <el-button
            type="primary"
            plain
            icon="el-icon-plus"
            size="mini"
            @click="handleAdd">新增
        </el-button>
      </el-col>-->
<!--      <el-col :span="1.5">
        <el-button
            type="success"
            plain
            icon="el-icon-edit"
            size="mini"
            :disabled="single"
            @click="handleUpdate">修改
        </el-button>
      </el-col>-->
<!--      <el-col :span="1.5">
        <el-button
            type="danger"
            plain
            icon="el-icon-delete"
            size="mini"
            :disabled="multiple"
            @click="handleDelete">删除
        </el-button>
      </el-col>-->
    </el-row>

    <el-table
        :data="recordList"
        :header-cell-style="{ background: 'rgb(250,250,250)' }"
        style="width: 100%">
      <el-table-column type="selection" width="55" align="center"/>
      <el-table-column label="企业编码" align="center" prop="companyCode"/>
      <el-table-column label="危险源编码" align="center" prop="hazardCode"/>
      <el-table-column label="任务编号" align="center" prop="taskId"/>
      <el-table-column label="检查类型" align="center" prop="checkType">
        <template slot-scope="scope">
          <el-link>{{ handleType(scope.row.checkType) }}</el-link>
        </template>
      </el-table-column>
      <el-table-column label="检查日期" align="center" prop="checkDate" width="250">
        <template slot-scope="{ row }">
          <span v-if="row.checkDate">{{ row.checkDate | timeFilter }}</span>
        </template>
      </el-table-column>
      <el-table-column label="是否停产" align="center" prop="resultStatus">
        <template slot-scope="{ row }">
          {{ row.resultStatus === 0 ? '正常' : '停产整顿' }}
        </template>
      </el-table-column>
      <!-- <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
         <template slot-scope="scope">
           <el-button
               size="mini"
               type="text"
               icon="el-icon-edit"
               @click="handleUpdate(scope.row)">修改
           </el-button>
           <el-button
               size="mini"
               type="text"
               icon="el-icon-delete"
               @click="handleDelete(scope.row)">删除
           </el-button>
         </template>
       </el-table-column>-->
    </el-table>


    <!-- 添加或修改检查情况记录对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="800px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="130px">
        <el-form-item label="重大危险源" prop="hazardCode">
          <el-select v-model="form.hazardCode" placeholder="请选择重大危险源">
            <el-option
                v-for="dict in dangerList"
                :key="dict.id"
                :label="dict.name"
                :value="dict.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="任务编号" prop="taskId" >
          <el-input v-model="form.taskId" disabled="disabled"/>
        </el-form-item>
        <el-form-item label="检查类型" prop="checkType">
          <el-select v-model="form.checkType" placeholder="请选择检查类型" style="width: 100%">
            <el-option v-for="item in checkTypeArr"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value"/>
          </el-select>
        </el-form-item>
        <el-form-item label="检查日期" prop="checkDate">
          <el-date-picker clearable
                          v-model="form.checkDate"
                          type="date"
                          value-format="yyyy-MM-dd"
                          placeholder="请选择辨识时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="创建人" prop="creator">
          <el-input v-model="form.creator" placeholder="请输入创建人"/>
        </el-form-item>
        <el-form-item label="是否停产" prop="resultStatus">
          <el-select v-model="form.resultStatus" style="width: 100%">
            <el-option :value="0" label="正常"/>
            <el-option :value="1" label="停产整顿"/>
          </el-select>
        </el-form-item>
        <el-form-item label="数据推送省厅" prop="isTest">
          <el-select v-model="form.isTest" style="width: 100%">
            <el-option :value="0" label="是"/>
            <el-option :value="1" label="否"/>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {addRecord, delRecord, getRecord, listRecord, updateRecord} from "@/api/specialExamination/record";
import {listTask} from "@/api/specialExamination/task";
import {hazardInstallationsList} from "@/api/majorHazard";
export default {
  name: "Record",
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      curPage: 1,
      pageSize: 10,
      // 检查情况记录表格数据
      recordList: [],
      //重大危险源
      dangerList : [],
      taskList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,

      checkTypeArr: [
        {label: "企业自查", value: 1},
        {label: "市级及以下检查", value: 2},
        {label: "省级检查", value: 3},
        {label: "部级检查", value: 4},
      ],
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        companyCode: null,
        hazardCode: null,
        taskId: null,
        checkType: null,
        checkDate: null,
        resultStatus: null,
        createDate: null,
        updateData: null,
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: {}
    };
  },
  created() {
    this.getList();
   // this.getTaskList();
    this.getHazardInstallationsList();
  },
  methods: {
    /** 查询检查况记录列表 */
    getList() {
      this.loading = true;
      listRecord({limit: this.pageSize, curPage: this.curPage, type: 0, isPage: 1}).then(response => {
        this.recordList = response.body.data;
        this.total = response.body.cum
      });
    },
    getTaskList(){
      listTask().then(response =>{
        console.log(response)
        //this.taskList = response.body.data;
      });
    },
    getHazardInstallationsList() {
      hazardInstallationsList().then(res => {
        this.dangerList = res.body.data
      })
    },
    handleType(type) {
      let list = this.checkTypeArr.filter(item => item.value === type)
      return list[0].label
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        id: null,
        companyCode: null,
        hazardCode: null,
        taskId: null,
        checkType: null,
        checkDate: null,
        resultStatus: null,
        createDate: null,
        createBy: null,
        updateData: null,
        updateBy: null
      };
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.handleQuery();
    },

    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = "添加专项检查情况记录列表";
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      const recordId = row.recordId
      getRecord(recordId).then(response => {
        this.form = response.body.data;
        this.open = true;
        this.title = "修改专项检查情况记录列表";
      });
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.form.recordId != null) {
            updateRecord(this.form).then(response => {
              this.open = false;
              this.getList();
            });
          }
        }
      });
    },
    /** 删除按钮操作  */
    handleDelete(row) {
      delRecord(row.recordId).then(res => {
        this.$message.success('删除成功')
        this.getList()
      })
    },
  }
};
</script>
